define([], function() {

  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneObject(object) {
    var Ctor = object.constructor;
    if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
      Ctor = Object;
    }
    return new Ctor;
  }

  return initCloneObject;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-amd/modern/internal/initCloneObject.js
// module id = 649
// module chunks = 0